import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService, PROJECT_CONTEXT_TOKEN } from '@cosmos/angular/utils';
import { Stage } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StagesService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  find(query=''): Observable<HttpResponse<Stage[]>> {
    return this.http
      .get<Stage[]>(`${environment.API_URL}/stages${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  findById(id: string, query = ''): Observable<HttpResponse<Stage>> {
    return this.http
      .get<Stage>(`${environment.API_URL}/stages/${id}${query}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  create(body: Stage, projectId?: string) {
    const context = projectId ? new HttpContext().set(PROJECT_CONTEXT_TOKEN, projectId) : undefined;
    return this.http
      .post(`${environment.API_URL}/stages`, body, {observe: 'response', context})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  update(body: any, projectId?: string) {
    const context = projectId ? new HttpContext().set(PROJECT_CONTEXT_TOKEN, projectId) : undefined;
    return this.http
      .patch(`${environment.API_URL}/stages/${body[0]}`, body[1], {observe: 'response', context})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  delete(id: string) {
    return this.http
      .delete(`${environment.API_URL}/stages/${id}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  getTree(id: string): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${environment.API_URL}/stages/${id}/tree`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  getAncestors(id: string): Observable<HttpResponse<{_id: string, name: string}[]>> {
    return this.http
      .get<{_id: string, name: string}[]>(`${environment.API_URL}/stages/${id}/ancestors`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  // Batched sibling of getTree — fetches N root stages' full descendant
  // trees in a single request instead of N separate ones. Use this instead
  // of forkJoin(ids.map(id => getTree(id))) anywhere more than one root
  // tree is needed at once (project-wide tree pickers) — the N-request
  // pattern hits rate limits outright on projects with 100+ root stages.
  getForest(ids: string[]): Observable<HttpResponse<any[]>> {
    return this.http
      .post<any[]>(`${environment.API_URL}/stages/tree`, { ids }, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

}
